<template lang="pug">
v-dialog(:value="dialog", persistent, scrollable, width="1200")
  v-card(v-if="selectedUserflow")
    v-card-title.headline(v-text="selectedUserflow.flow.name")
    v-progress-linear(:value="progress * 100")
    v-card-text.pa-4(v-if="currentStep")
      .pa-4
        .quiz.pa-3
          h2.mb-2(v-text="question.title")
            v-tooltip(v-if="question.info", bottom, max-width="300")
              template(v-slot:activator="{ on }")
                v-icon.ml-2(v-on="on") mdi-information-outline
              span(v-text="question.info") 
          h3(v-html="question.subtitle")
          p.pa-2(v-if="question.body", v-text="question.body")
          div(
            v-for="(abLoop, lIndex) in quizAnswers.length / question.answer_blocks.length"
          )
            AnswerBlock(
              v-for="(abData, i) in question.answer_blocks",
              :key="i",
              :answer_block_data="abData",
              :value="quizAnswers[getAnswerIndex(lIndex, i)]",
              @input="changeInput(getAnswerIndex(lIndex, i), $event)"
            )
          v-btn(v-if="question.is_looped", color="primary", @click="addLoop") + Add
          v-card-actions
            v-btn(v-if="canUndo", text, @click="goStepBack") 
              v-icon(left) mdi-step-backward
              span back
            v-spacer
            v-btn(
              color="primary",
              @click="answerStep",
              :loading="isUserflowLoading",
              :disabled="!canGoNext"
            ) next
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import AnswerBlock from "./AnswerBlock";

export default {
  name: "quiz",

  components: {
    AnswerBlock,
  },

  watch: {
    dialog(val) {
      if (val) {
        window.addEventListener('keypress', this.keyListener);
      } else {
        window.removeEventListener('keypress', this.keyListener);
      }
    }
  },
  computed: {
    ...mapState("flows/quiz", [
      "isUserflowLoading",
      "currentStep",
      "progress",
      "selectedUserflow",
      "canUndo",
      "quizAnswers",
    ]),
    ...mapGetters("flows/quiz", ["canGoNext"]),

    dialog() {
      return this.selectedUserflow !== null;
    },

    question() {
      return this.currentStep?.question;
    },
  },
  methods: {
    ...mapMutations("flows/quiz", ["addLoop"]),
    ...mapActions("flows/quiz", ["answerStep", "goStepBack"]),
    keyListener(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        if(this.canGoNext) {
          this.answerStep()
        }
      }
    },
    getAnswerIndex(lIndex, abIndex) {
      return abIndex + this.question.answer_blocks.length * lIndex;
    },

    changeInput(index, value) {
      this.$store.commit("flows/quiz/changeQuizAnswer", { index, value });
    },
  },
};
</script>